export default __webpack_public_path__ + "static/media/bit-greet-black.4ed8b614.svg";